export var propsOmittedFromClickData = [
    'onBlur',
    'onClick',
    'onFocus',
    'onKeyDown',
    'onKeyUp',
    'onMouseDown',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseUp',
];
//# sourceMappingURL=constants.js.map